
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetooutstationurbania() {



  const cardData =
  {
    keyword: ' Pune to Outstation Urbania Bus Hire in Pune',
    heading: 'Vaishnavi Travels: Pune to Outstation Urbania Bus Hire in Pune',
    headingDescription: 'Vaishnavi Travels provides convenient and affordable Pune to Outstation Urbania Bus Hire in Pune, perfect for family tours, weddings, corporate outings, school trips, and pilgrimages. Our Urbania buses are well-maintained with spacious push-back seating, modern interiors, powerful air-conditioning, and ample luggage space, ensuring a smooth and comfortable ride on long-distance routes. With professional chauffeurs, punctual service, and flexible booking options, we make outstation group travel stress-free and enjoyable. Whether it’s a holiday vacation, business trip, or religious yatra, Vaishnavi Travels guarantees safe, reliable, and comfortable Urbania bus rental services from Pune to any outstation destination.',

    top: 'Top Places to Visit in Pune Outstation with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Lonavala and Khandala",
    "description": "Just 65 km from Pune, the twin hill stations of Lonavala and Khandala are the most loved weekend getaways. Famous for misty valleys, waterfalls, and scenic ghats, they are perfect in monsoon. Tourists enjoy Bhushi Dam, Tiger’s Leap, Karla Caves, and Rajmachi Fort. The Mumbai-Pune Expressway drive itself is a visual delight. Families, trekkers, and honeymooners flock here year-round. Lonavala and Khandala are Pune’s refreshing outstation escapes."
  },
  {
    "title": "Mahabaleshwar and Panchgani",
    "description": "Located 120 km from Pune, Mahabaleshwar and Panchgani are famous for their strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Table Land. Venna Lake boating, Mapro Garden, and Tapola backwaters are popular attractions. The old Mahabaleshwar Temple adds spiritual significance. Monsoon enhances its beauty with waterfalls and mist. The cool weather makes it a summer favorite. Mahabaleshwar and Panchgani are Pune’s evergreen hill station retreats."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi, 200 km from Pune, is one of India’s holiest pilgrim towns dedicated to Sai Baba. The Samadhi Mandir, Dwarkamai, Chavadi, and Lendi Baug draw lakhs of devotees every year. Pilgrims feel peace and devotion in the temple’s spiritual aura. The town also offers Sai Museum and Sai Heritage Village. Many combine it with Shani Shingnapur nearby. Shirdi is Pune’s most sacred outstation destination for spiritual seekers."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Around 160 km from Pune, Shani Shingnapur is a unique village where Lord Shani is worshipped in an open-air shrine. The village is famous for houses without doors, symbolizing faith in divine protection. Pilgrims believe worship here removes obstacles and brings discipline in life. Saturdays see huge crowds for special pujas. Devotees often combine this trip with Shirdi. Shani Shingnapur is Pune’s outstation landmark of trust and devotion."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, just 60 km from Pune, is India’s first planned hill city inspired by Italian architecture. Nestled around Warasgaon Lake, it features lakeside promenades, colorful buildings, and luxury resorts. Tourists enjoy boating, cycling, and adventure sports. Couples love its romantic charm, while families relax in its peaceful surroundings. Its Instagram-worthy landscapes make it a photography hotspot. Lavasa is Pune’s modern outstation getaway of leisure and style."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, 140 km from Pune, is a popular coastal town known for clean beaches and water sports. Tourists enjoy Alibaug Beach, Nagaon Beach, and Kashid Beach, along with parasailing and jet skiing. The Kolaba Fort, located amidst the sea, adds historic charm. Beach resorts and seafood enhance the experience. Weekend travelers often combine Alibaug with Murud-Janjira Fort. Alibaug is Pune’s beachside outstation retreat for fun and relaxation."
  },
  {
    "title": "Nashik",
    "description": "About 210 km from Pune, Nashik is famous as India’s wine capital and a spiritual hub on the Godavari River. The Trimbakeshwar Jyotirlinga and Kumbh Mela make it sacred for Hindus. Wine tours at Sula and York wineries attract modern travelers. The city combines temples, ghats, and vineyard tourism seamlessly. Scenic drives around Brahmagiri Hills add charm. Nashik is Pune’s versatile outstation blend of devotion and leisure."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur, 230 km from Pune, is a historic city known for the Mahalaxmi Temple, one of the Shakti Peethas. Visitors also explore Panhala Fort, Rankala Lake, and the New Palace Museum. The city is famous for spicy Kolhapuri cuisine and handcrafted chappals. Pilgrims, foodies, and history lovers all find something here. Festivals and traditions keep its culture vibrant. Kolhapur is Pune’s outstation destination for heritage and devotion."
  },
  {
    "title": "Goa",
    "description": "Goa, 450 km from Pune, is India’s ultimate beach and party destination. North Goa offers lively beaches, nightlife, and shopping, while South Goa is calm with luxury resorts. Dudhsagar Waterfalls, forts, and Portuguese churches add heritage appeal. Seafood, casinos, and water sports make it diverse and exciting. The Pune–Goa road trip via Kolhapur is also scenic. Goa is Pune’s top outstation vacation spot for fun and relaxation."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar, 110 km from Pune, is one of the 12 Jyotirlingas dedicated to Lord Shiva. The temple sits amidst the Bhimashankar Wildlife Sanctuary, home to the Indian Giant Squirrel. Trekkers enjoy scenic trails through dense forests, waterfalls, and valleys. Monsoon enhances its natural beauty with mist and greenery. Pilgrims flock here during Mahashivratri and Shravan. Bhimashankar is Pune’s sacred and adventurous outstation escape."
  }
],


      "services": [
    {
      "name": "Urbania Bus Hire Pune Outstation",
      "description": "Experience hassle-free outstation travel with our Urbania bus hire service in Pune. Our 13 and 17 seater vans are perfect for long-distance trips, offering spacious seating, efficient air conditioning, and ample luggage space. Whether you're heading to hill stations, pilgrimage sites, or business destinations, our reliable vans ensure a comfortable journey with professional drivers familiar with highway routes and safety protocols."
    },
    {
      "name": "Force Urbania for Long Distance Travel",
      "description": "Travel in comfort and safety with our Force Urbania vans specially equipped for long-distance travel. Built for durability and smooth rides on Indian roads, these vans provide extra legroom, cushioned seats, and powerful AC systems. Ideal for group tours, corporate travel, and family vacations, our Force Urbania vans come with experienced drivers and round-the-clock customer support to ensure your trip is seamless."
    },
    {
      "name": "Pune to Outstation Urbania Rental",
      "description": "Planning a trip from Pune to nearby or distant outstation locations? Our Urbania rental service offers flexible packages including hourly, daily, and multi-day rentals. With comfortable seating, onboard amenities, and skilled drivers, your group can enjoy stress-free travel to destinations like Lonavala, Shirdi, Mahabaleshwar, Goa, and beyond. We handle route planning and provide real-time support for all bookings."
    },
    {
      "name": "AC Urbania with Driver Pune",
      "description": "Stay cool and relaxed on your journeys with our air-conditioned Urbania vans available with professional drivers in Pune. These vans feature individually controlled AC vents, ergonomic seats, and a quiet cabin environment ideal for hot weather and long-distance drives. Our courteous drivers ensure punctual pickups, safe driving, and assistance throughout your trip."
    },
    {
      "name": "Group Tour Urbania Bus Pune",
      "description": "Organize your group tours with ease using our spacious Urbania buses in Pune. Whether for school trips, corporate retreats, family outings, or religious tours, our 13 and 17 seater vans can accommodate your entire group comfortably. We offer group discounts, multiple vehicle dispatch, and tailored itineraries with stops at popular tourist spots, ensuring a smooth and enjoyable travel experience."
    },
    {
      "name": "Outstation Corporate Urbania Hire",
      "description": "Boost your corporate travel efficiency with our dedicated outstation Urbania hire service in Pune. Perfect for team offsites, conferences, client visits, and airport transfers, our vans come with clean interiors, Wi-Fi connectivity, charging ports, and professional drivers. Flexible rental durations and competitive pricing make us the preferred choice for business travel across Maharashtra."
    },
    {
      "name": "Weekend Urbania Ride from Pune",
      "description": "Make your weekend trips memorable with our Urbania ride packages from Pune. Explore destinations like Lonavala, Matheran, Alibaug, or Goa in a comfortable van that accommodates families, friends, and corporate groups. Choose from one-day or multi-day rentals with options for customizable pick-up points and scenic stopovers. Our vans ensure a safe, relaxed, and fun weekend getaway."
    },
    {
      "name": "Family Outstation Van Hire Pune",
      "description": "Travel with your family in comfort and safety with our Urbania van hire service in Pune. Designed for family outings to religious sites, hill stations, or beach resorts, our vans include child safety features, spacious interiors, and entertainment options. Our drivers are trained to be courteous and responsive, making your family trips enjoyable and hassle-free."
    },
    {
      "name": "Urbania Bus for Religious Tour Pune",
      "description": "Plan your spiritual journeys with our Urbania buses specially tailored for religious tours from Pune. Whether visiting temples, pilgrimage sites, or holy festivals, our vans offer comfortable seating, reliable AC, and ample space for luggage and offerings. Group bookings include route guidance, timely pickups, and courteous drivers familiar with key religious destinations."
    },
    {
      "name": "Urbania for Tourist Packages Pune",
      "description": "Enhance your sightseeing tours with our Urbania vans available for tourist package hires in Pune. Suitable for local city tours, hill station excursions, and multi-day travel plans, these vans provide panoramic windows, comfortable seats, and amenities like charging points and music systems. Customized tour packages with expert driver support make your trip both convenient and memorable."
    },
    {
      "name": "Multi-Day Trip Urbania Pune",
      "description": "Embark on extended journeys with our multi-day Urbania trip packages from Pune. Ideal for exploring multiple destinations, our vans come with flexible scheduling, daily maintenance, and driver accommodations for long-term comfort. Suitable for group tours, corporate retreats, and family vacations, our service ensures continuous support and hassle-free logistics throughout your trip."
    },
    {
      "name": "13/17 Seater Urbania Outstation Travel",
      "description": "Choose between 13 or 17 seater Urbania vans for your outstation travels from Pune. These vans combine maneuverability with spacious interiors, perfect for groups of varying sizes. Equipped with safety features, powerful AC, and ample storage, they provide an ideal balance of comfort and efficiency. Our packages include driver services, fuel management, and real-time tracking."
    },
    {
      "name": "Premium Outstation Urbania Rental Pune",
      "description": "Experience premium comfort with our outstation Urbania rentals in Pune featuring luxury interiors, leather seats, ambient lighting, and soundproof cabins. Designed for VIP travel, executive tours, and special occasions, these vans offer enhanced amenities like chilled beverages, infotainment systems, and multilingual drivers. Available on daily and multi-day bookings, our premium service caters to discerning travelers seeking sophistication on the road."
    }
  ],
  "tableData": [
    ["Urbania Bus Hire Pune Outstation", "Force Urbania for Long Distance Travel"],
    ["Pune to Outstation Urbania Rental", "AC Urbania with Driver Pune"],
    ["Group Tour Urbania Bus Pune", "Outstation Corporate Urbania Hire"],
    ["Weekend Urbania Ride from Pune", "Family Outstation Van Hire Pune"],
    ["Urbania Bus for Religious Tour Pune", "Urbania for Tourist Packages Pune"],
    ["Multi-Day Trip Urbania Pune", "13/17 Seater Urbania Outstation Travel"],
    ["Premium Outstation Urbania Rental Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Outstation Urbania Bus Hire in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers comfortable and reliable Force Urbania bus hire services for outstation trips from Pune, ideal for family outings, corporate tours, and group travel."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Urbania buses feature plush seats, ample legroom, and air conditioning to ensure a smooth and enjoyable journey for all passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly cleaned to provide a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Expertise in Outstation Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with outstation routes, ensuring timely, safe, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, full-day, or multi-day rental options customized to your travel schedule and group size."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Our all-inclusive pricing covers fuel, tolls, driver allowance, and taxes for a transparent and stress-free booking."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Events, Family Trips, and Group Tours",
    "WhyChoosedescription": "Perfect for business trips, weekend getaways, and sightseeing tours beyond Pune."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Smooth Booking",
    "WhyChoosedescription": "Our customer service team is available around the clock to assist with bookings, itinerary changes, and travel inquiries."
  }
]


















  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 13 seater Force Urbania bus hire for Pune to outstation trips?',
      answer: 'Yes, Vaishnavi Travels provides 13 seater Force Urbania bus rentals for Pune to outstation trips, ideal for group travel, corporate tours, and family vacations to various destinations.',
    },
    {
      question: 'What features does the 13 seater Force Urbania bus offer for outstation travel from Pune?',
      answer: 'The 13 seater Force Urbania comes with spacious seating, air-conditioning, comfortable legroom, modern interiors, and ample luggage space to ensure a smooth and comfortable long-distance journey.',
    },
    {
      question: 'Are the vehicles and drivers reliable for Pune to outstation Urbania bus hires?',
      answer: 'Absolutely! All vehicles are regularly maintained and serviced. Our experienced and courteous drivers are knowledgeable about outstation routes, ensuring safe and timely travel.',
    },
    {
      question: 'What is the rental cost for Pune to outstation Urbania bus hire?',
      answer: 'Rental costs typically start from ₹7,000 depending on distance, duration, and additional services requested.',
    },
    {
      question: 'Can I book the 13 seater Urbania bus for multi-day outstation trips from Pune?',
      answer: 'Yes, Vaishnavi Travels offers flexible packages for multi-day outstation trips with clear and transparent pricing.',
    },
    {
      question: 'How early should I book a 13 seater Urbania bus for outstation travel from Pune?',
      answer: 'It is recommended to book at least 3-4 days in advance, especially during peak travel seasons and holidays.',
    },
    {
      question: 'Is flexible pickup and drop-off available for Pune to outstation Urbania bus rentals?',
      answer: 'Yes, flexible pickup and drop locations are available in Pune and surrounding areas to best suit your travel itinerary.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Suresh Patil",
    position: "Tour Organizer",
    feedback:
      "Vaishnavi Travels provided an excellent 13 seater Urbania bus for our outstation trip from Pune. The vehicle was clean, comfortable, and the driver was professional throughout the journey.",
    rating: 5,
  },
  {
    name: "Ms. Neha Kulkarni",
    position: "Traveler",
    feedback:
      "Our outstation travel from Pune was smooth and enjoyable with Vaishnavi Travels’ Urbania bus hire. The service was prompt, and the vehicle was spacious and comfortable.",
    rating: 5,
    style: "style-2",
  }
];







































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Outstation Urbania Bus Hire",
  "image": "https://vaishnavitravel.com/assets/images/urbania-outstation-hire-pune.jpg",
  "description": "Book Force Urbania bus rental for outstation travel from Pune. Available in 13/17 seater AC and non-AC vans with experienced drivers. Ideal for group tours, corporate trips, family outings, and multi-day travel.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8500",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-outstation-urbania-bus-hire"
  }
};



  return (
    <div>
<Helmet>
  <title>Pune to Outstation Urbania Bus Hire | 13/17 Seater Force Urbania Rental</title>
  <meta
    name="description"
    content="Book Force Urbania bus rental for outstation travel from Pune. Available in 13/17 seater AC and non-AC vans with experienced drivers. Ideal for group tours, corporate trips, family outings, and multi-day travel."
  />
  <meta
    name="keywords"
    content="Urbania Bus Hire Pune Outstation, Force Urbania for Long Distance Travel, Pune to Outstation Urbania Rental, AC Urbania with Driver Pune, Group Tour Urbania Bus Pune, Outstation Corporate Urbania Hire, Weekend Urbania Ride from Pune, Family Outstation Van Hire Pune, Urbania Bus for Religious Tour Pune, Urbania for Tourist Packages Pune, Multi-Day Trip Urbania Pune, 13/17 Seater Urbania Outstation Travel, Premium Outstation Urbania Rental Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetooutstationurbania;